import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, Lock } from "lucide-react";

const STATUS_STYLES = {
  live: "text-tib-teal border-tib-teal/40",
  coming_soon: "text-tib-gold border-tib-gold/40",
  draft: "text-zinc-400 border-zinc-700",
  retired: "text-zinc-500 border-zinc-800",
};

const STATUS_LABEL = {
  live: "live",
  coming_soon: "coming soon",
  draft: "draft",
  retired: "retired",
};

export function ConfidentialName({ name, className = "" }) {
  return (
    <span className={`inline-flex items-baseline ${className}`}>
      {name}
      <span className="haze-block" aria-hidden="true">▐████▍</span>
    </span>
  );
}

export default function PlatformCard({ platform }) {
  const status = platform.status || "live";
  const isSoon = status === "coming_soon";
  const isConf = Boolean(platform.confidential);

  return (
    <Link
      to={`/platforms/${platform.slug}`}
      data-testid={`platform-card-${platform.slug}`}
      className="card-edge group relative flex flex-col overflow-hidden"
    >
      <div className="relative h-44 overflow-hidden">
        {isSoon ? (
          <div
            className="w-full h-full flex items-center justify-center"
            style={{
              backgroundImage:
                "radial-gradient(circle at 30% 30%, rgba(47,107,255,0.20), transparent 55%), radial-gradient(circle at 75% 70%, rgba(124,63,228,0.18), transparent 55%), linear-gradient(#0a0a0a,#0a0a0a)",
            }}
          >
            <img src="/tib-logo.png" alt="" className="w-20 h-20 object-contain opacity-70 mix-blend-screen group-hover:scale-110 transition-transform duration-700" />
          </div>
        ) : (
          <>
            <img
              src={platform.hero_image_url}
              alt={platform.name}
              className="w-full h-full object-cover opacity-60 group-hover:opacity-80 group-hover:scale-105 transition-all duration-700"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
          </>
        )}
        <div className={`absolute top-3 left-3 text-[0.62rem] font-mono uppercase tracking-widest px-2 py-1 border bg-black/60 flex items-center gap-1.5 ${isConf ? "text-tib-gold border-tib-gold/40" : (STATUS_STYLES[status] || STATUS_STYLES.live)}`}>
          {isConf ? <Lock className="w-3 h-3" /> : (isSoon && <Clock className="w-3 h-3" />)}
          {isConf ? "confidential" : (STATUS_LABEL[status] || status)}
        </div>
      </div>
      <div className="p-6 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-3">
          <h3 className="h-serif text-2xl text-white">
            {isConf ? <ConfidentialName name={platform.name} /> : platform.name}
          </h3>
          <ArrowUpRight className="w-5 h-5 text-zinc-600 group-hover:text-tib-gold group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-all" />
        </div>
        <p className="mt-3 text-sm text-zinc-400 leading-relaxed flex-1">{platform.tagline}</p>
        <div className="mt-5 flex flex-wrap gap-2">
          {(platform.categories || []).map((c) => (
            <span key={c} className="text-[0.62rem] font-mono uppercase tracking-widest text-zinc-500 border border-zinc-800 px-2 py-1">
              {c}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}
